/**
 * Start-screen illustration: stylised Vierwaldstättersee silhouette with red shore bands.
 * Outline derived once from the swissTLM3D lake outline (simplified ~70 m, smoothed),
 * projected to a 400 x 340 viewBox. Decorative only.
 */

const LAKE_D = [
  'M183 9Q181 8 172 21Q163 34 160 36Q158 38 155 37Q153 36 151 38Q148 39 145 42Q142 46 140 49',
  'Q138 52 138 53Q138 54 138 54Q137 54 137 54Q136 53 137 54Q137 54 132 58Q126 62 121 68Q116 74 113 75',
  'Q111 76 106 82Q101 88 96 87Q90 86 91 83Q91 80 88 75Q86 71 81 67Q77 62 74 62Q71 61 70 57Q68 53 60 53',
  'Q53 52 47 54Q42 55 42 57Q42 58 43 58Q45 58 47 61Q50 65 51 64Q52 63 52 64Q53 66 54 65Q55 65 56 66',
  'Q58 67 56 68Q54 68 57 70Q59 73 62 72Q65 72 65 74Q65 77 66 79Q66 81 70 85Q74 88 75 90Q76 92 74 95',
  'Q72 97 72 100Q72 103 75 108Q79 112 77 113Q75 115 77 117Q78 119 77 121Q76 123 77 128Q78 132 71 137',
  'Q64 141 60 138Q56 136 55 132Q54 128 51 125Q49 122 44 125Q39 128 38 130Q38 132 41 136Q44 140 47 149',
  'Q50 158 48 161Q46 164 45 169Q45 175 55 175Q64 174 65 175Q66 176 66 180Q66 183 58 187Q49 191 45 191',
  'Q40 191 33 194Q26 196 25 199Q25 201 18 205Q11 209 10 212Q8 214 10 216Q11 217 13 216Q15 214 14 216',
  'Q14 217 14 217Q15 218 16 216Q18 214 18 216Q18 218 20 218Q21 217 20 216Q20 214 21 213Q22 213 21 215',
  'Q21 218 22 218Q23 218 24 217Q24 216 25 216Q25 217 24 218Q23 218 25 220Q28 222 32 218Q36 214 50 206',
  'Q64 199 66 196Q68 194 70 194Q71 194 70 193Q70 193 72 190Q74 188 74 188Q73 188 72 185Q72 182 70 181',
  'Q68 180 68 178Q68 175 75 173Q83 171 86 168Q88 165 88 163Q88 161 91 157Q93 153 97 151Q101 148 104 142',
  'Q107 136 129 136Q151 136 157 137Q164 139 170 138Q177 137 182 139Q188 141 191 140Q194 139 200 140',
  'Q207 141 209 143Q212 146 209 148Q206 150 196 151Q186 152 175 157Q163 162 162 166Q162 171 163 172',
  'Q165 173 165 174Q164 176 165 175Q166 175 166 174Q165 173 167 175Q168 176 169 176Q171 175 170 177',
  'Q169 178 171 180Q172 182 180 182Q188 183 194 186Q201 189 208 188Q216 187 223 194Q230 200 239 202',
  'Q249 203 255 203Q262 203 262 202Q262 202 265 201Q269 200 276 196Q284 192 296 189Q308 186 314 182',
  'Q320 179 320 177Q321 176 326 173Q331 170 342 165Q352 161 356 163Q359 165 360 167Q361 169 358 175',
  'Q355 181 357 188Q358 195 357 198Q357 202 355 205Q353 207 353 211Q353 214 350 220Q348 227 348 229',
  'Q348 232 345 239Q342 245 342 246Q343 248 341 250Q340 252 341 254Q341 257 346 261Q350 266 355 270',
  'Q361 274 358 278Q356 282 355 288Q355 295 356 300Q357 305 358 305Q359 306 358 309Q357 312 360 316',
  'Q363 321 366 322Q369 322 370 320Q370 318 370 318Q369 318 371 316Q373 314 372 314Q371 313 373 313',
  'Q374 312 375 309Q375 307 378 305Q381 304 381 306Q382 307 383 307Q384 306 383 307Q383 307 384 307',
  'Q384 307 385 308Q385 309 384 309Q384 309 384 309Q385 309 385 309Q385 309 385 307Q384 306 386 305',
  'Q388 304 388 303Q388 301 387 302Q387 302 389 301Q391 301 391 296Q392 292 390 289Q388 285 388 282',
  'Q389 278 390 277Q390 276 389 273Q387 269 382 266Q377 262 377 260Q378 259 377 258Q376 257 379 247',
  'Q382 238 384 235Q387 231 387 229Q387 228 386 226Q385 224 386 221Q387 219 385 216Q383 212 382 210',
  'Q382 208 381 208Q380 208 381 207Q381 206 380 199Q379 192 377 189Q376 185 377 174Q377 163 375 158',
  'Q373 154 364 151Q355 149 354 147Q353 144 351 142Q348 140 342 141Q335 142 333 145Q330 147 327 148',
  'Q325 148 320 153Q316 157 312 158Q308 160 300 160Q292 161 289 159Q286 157 283 157Q280 157 279 155',
  'Q278 153 275 152Q272 151 261 154Q250 157 248 157Q245 157 241 154Q236 151 234 151Q232 152 228 151',
  'Q224 149 226 147Q228 145 228 144Q227 143 232 140Q237 137 236 134Q234 130 234 125Q233 119 228 117',
  'Q224 114 221 110Q218 107 218 105Q218 103 210 103Q203 103 198 98Q193 93 188 91Q182 89 177 90',
  'Q171 91 169 93Q166 95 160 94Q154 93 149 96Q144 99 144 99Q143 98 144 97Q145 95 145 95Q145 95 142 96',
  'Q139 98 138 96Q138 94 140 91Q143 88 144 86Q144 84 147 81Q150 77 156 74Q163 70 168 63Q172 56 172 51',
  'Q172 45 174 43Q176 40 177 32Q178 23 179 22Q181 21 181 19Q181 16 184 15Q186 14 186 12Q186 11 183 9Z',
].join('');

/** Contour rings around the shore: [stroke width, line opacity]. */
const CONTOURS: [number, number][] = [
  [92, 0.07],
  [62, 0.1],
  [36, 0.14],
  [16, 0.18],
];

export function lakeArtSvg(): string {
  const rings = CONTOURS.map(
    ([w, o]) =>
      `<use href="#uz-lake" fill="none" stroke="rgba(170,215,235,${o})" stroke-width="${w + 2.4}"/>` +
      `<use href="#uz-lake" fill="none" stroke="#0a2230" stroke-width="${w}"/>`,
  ).join('');
  return `<svg class="uz-start-art-svg" viewBox="-20 -24 440 388" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
  <defs>
    <path id="uz-lake" d="${LAKE_D}" stroke-linejoin="round"/>
    <clipPath id="uz-lake-clip"><use href="#uz-lake"/></clipPath>
    <linearGradient id="uz-water" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#3aa6d8"/>
      <stop offset="1" stop-color="#11557d"/>
    </linearGradient>
    <linearGradient id="uz-cone" x1="0" y1="1" x2="0" y2="0">
      <stop offset="0" stop-color="#fff" stop-opacity=".55"/>
      <stop offset="1" stop-color="#fff" stop-opacity="0"/>
    </linearGradient>
  </defs>
  <g stroke-linejoin="round">${rings}</g>
  <use href="#uz-lake" fill="url(#uz-water)"/>
  <g clip-path="url(#uz-lake-clip)" stroke-linejoin="round">
    <use href="#uz-lake" fill="none" stroke="#ff2a36" stroke-opacity=".42" stroke-width="15"/>
    <use href="#uz-lake" fill="none" stroke="#e30613" stroke-opacity=".95" stroke-width="6"/>
  </g>
  <use href="#uz-lake" fill="none" stroke="#fff" stroke-opacity=".55" stroke-width=".8"/>
  <g transform="translate(166 116)">
    <path d="M0 0L-62 -44A76 76 0 0 1 -30 -70Z" fill="url(#uz-cone)"/>
    <circle r="11" fill="#fff" fill-opacity=".18"/>
    <path d="M0 -8L6 7L0 4L-6 7Z" fill="#fff" transform="rotate(-50)"/>
  </g>
  <g font-family="system-ui, Roboto, sans-serif" font-weight="700" fill="#e8f2f7">
    <circle cx="42" cy="60" r="3.2" fill="#fff"/>
    <text x="36" y="47" font-size="13" text-anchor="middle" letter-spacing=".5">Luzern</text>
  </g>
  <g transform="translate(386 6)" fill="#e8f2f7" font-family="system-ui, Roboto, sans-serif" font-weight="800">
    <path d="M0 -14L6 4L0 0L-6 4Z" fill="#fff"/>
    <text y="20" font-size="12" text-anchor="middle">N</text>
  </g>
</svg>`;
}
